import { calculateConversionValueFromShipmentFrequency } from "./calculateConversionValueFromShipmentFrequency";

// OpenAI takes conversion amounts as integer cents
export function calculateOpenAiConversionAmountCents(
  shipmentFrequency: string | undefined,
): number {
  return Math.round(
    calculateConversionValueFromShipmentFrequency(shipmentFrequency) * 100,
  );
}

// OpenAI matches users via SHA-256 of the trimmed, lowercased email,
// as a lowercase hex string. Raw emails must never be sent.
export async function emailSha256LowercaseHex(email: string): Promise<string> {
  const bytes = new TextEncoder().encode(email.trim().toLowerCase());
  const digest = await crypto.subtle.digest("SHA-256", bytes);
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, "0"))
    .join("");
}
